
const routes = [
  {
    path: '/',
    name: 'realTimeMonitoringH5',
    component: () => import('@/views_h5/monitoring/index.vue')
  },
]

export default routes


// WEBPACK FOOTER //
// ./src/router/routerH5.js